import ReturnsCartSlide from './ReturnsCartSlide';
import { IInitialState } from 'src/store/initialState';
import {
  partsToReturnSel,
  rmaListSel,
  returnsActions
} from 'src/store/modules/returns';
import {
  IEligibleItem,
  IReturnOptionConfig,
  IStatusFilter,
  IReturnGenerateShippingLabel,
  IReturnGenerateShippingLabelResponse,
  IReturnShippingConfig
} from 'src/services/returns/typings';
import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: IInitialState) => ({
  partsToReturn: partsToReturnSel(state),
  rmaList: rmaListSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  removePartFromReturnList: (id: number) => {
    dispatch(returnsActions.removePartFromReturnList(id));
  },

  showSubmitAlert: (rmaNumber: string) => {
    dispatch(
      returnsActions.setReturnAlert({
        show: true,
        message: `Return No. ${rmaNumber} has been submitted.`,
        type: 'success',
        icon: 'rpds-check-circle'
      })
    );
  },

  editPartFromReturnList: (part: IEligibleItem) => {
    dispatch(returnsActions.editPartFromReturnList(part));
  },

  onSaveForLater: (config: IReturnOptionConfig, callback?: () => void) => {
    dispatch(returnsActions.onSaveForLater(config, callback));
  },

  onSubmitNow: (config: IReturnShippingConfig, callback?: () => void) => {
    dispatch(returnsActions.onSubmitNow(config, callback));
  },

  onUpdateNow: (config: IReturnShippingConfig,callback?: () => void) => {
    dispatch(returnsActions.onUpdateNow(config,callback));
  },

  onGenerateShippingLabel: (upsRequest: IReturnGenerateShippingLabel, callback?: () => void) => {
    dispatch(returnsActions.onGenerateShippingLabel(upsRequest, callback));
  },

  getStatusItems: (body?: IStatusFilter) => {
    dispatch(returnsActions.getStatusItems(body));
  },

  getRMALists: (body?: IStatusFilter) => {
    dispatch(returnsActions.getRMALists(body));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(ReturnsCartSlide));
